<ul class="list-group list-group-flush bg-white position-absolute h-100 w-100 z-3">
  @for (item of navItems; track item) {
    @if (shouldShowNavItem(item)) {
      <li
        class="list-group-item d-flex align-items-center py-3 gap-3 list-group-item-action"
        [ngClass]="{
          'fw-bold list-group-item-primary': isNavItemActive(item),
          'disabled': isNavItemDisabled(item),
          'text-muted': isNavItemHiddenByOrgSettings(item) && isOnAdminPage
        }"
        (click)="navigate(item)">
        <i class="fa-solid {{item.icon}} fa-xl text-center"></i>

        <span class="fs-3">
          {{item.label}} @if (isNavItemDisabled(item)) {
            <i class="ms-1 fa-solid fa-lock"></i>
          }
        </span>
      </li>
    }
  }

  @if (showAdminLink) {
    <li
      class="list-group-item d-flex align-items-center py-3 gap-3 list-group-item-action"
      [ngClass]="{'fw-bold list-group-item-primary': currentModule === adminNavItem.module}"
      (click)="navigateAdmin()">
      <i class="fa-solid {{adminNavItem.icon}} fa-xl text-center"></i>

      <span class="fs-3">{{adminNavItem.label}}</span>
    </li>
  }

  <li class="list-group-item d-flex align-items-center py-3 gap-3 list-group-item-action" role="button"
    data-bs-toggle="modal" data-bs-target="#staticBackdrop">
    <i class="fa-solid fa-circle-user fa-xl text-center"></i>

    <span class="fs-3">Account</span>
  </li>
</ul>
